<template>
  <div v-if="showModal" class="side__modal side__modal__document__wide opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.DISTRIBUTION }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <form class="modal__footer"
            @submit.prevent="submit">

        <div v-for="resolutionSection in form.employeeSelect" :key="resolutionSection.section"
             class="mb-4 border border-blue-300 py-2">
          <h4 class="mb-1 font-medium text-lg">
            {{ resolutionSection.name }}
          </h4>
          <Executors :executors="resolutionSection.executors"
                     :resolution="resolution">
            <template v-slot:actions>
              <button type="button" class="title__icon" @click="showSelectEmployeesModalSection = resolutionSection.section">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                </svg>
              </button>
            </template>
          </Executors>
          <SelectEmployeesModal v-if="showSelectEmployeesModalSection === resolutionSection.section"
                                :key="resolutionSection.section"
                                :section="resolutionSection"
                                :default-employees="defaultEmployees"
                                :executors="resolutionSection.executors"
                                @submit="addExecutors"
                                @close="showSelectEmployeesModalSection = null"/>
        </div>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="relative button button__modal__close"
                  :disabled="submitting">
            {{ $lang.app.SAVE }}
            <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
              <div class="block animate-spin">
                <RefreshIcon class="w-6 h-6 mirror-y"/>
              </div>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Executors from "../DistributionExecutors"
import SelectEmployeesModal from "./SelectEmployeesModal"
import applicationApi from "../../../../../api/employee/application"
import resolutionApi from "../../../../../api/employee/resolution"
import executorTypes from "../../../../../helpers/constants/executorTypes";

export default {
  props: {
    resolution: Object
  },
  components: {
    Executors,
    SelectEmployeesModal
  },
  data() {
    return {
      showModal: false,

      submitting: false,

      form: {
        employeeSelect: null
      },

      showSelectEmployeesModalSection: null,
      defaultEmployees: [],
    };
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    initForm() {
      applicationApi.getApplicationSections(this.$route.params.applicationId)
          .then(res => {
            this.form.employeeSelect = res.map(item => ({
              section: item.id,
              name: item.docType.name,
              executors: [],
            }))
          }).catch(error => {
            this.$snotify.error(error)
          })
    },
    addExecutors(data) {
      let index = this.form.employeeSelect.findIndex(item => item.section === data.section)
      this.form.employeeSelect[index].executors = data.employees
      this.showSelectEmployeesModalSection = null
      this.setDefaultEmployees(data.employees.map(e => ({...e, type: executorTypes.getValueByKey('EXECUTOR')})))
    },
    setDefaultEmployees(employees) {
      employees.forEach(employee => {
        if (!this.defaultEmployees.some(e => e.id === employee.id)) {
          this.defaultEmployees.push(employee)
        }
      })
    },
    submit() {
      this.submitting = true
      resolutionApi.distributeResolution(this.resolution.id, {
        employeeSelect: this.form.employeeSelect.map(s => ({
          section: s.section,
          executors: s.executors.map(e => ({
            employment: e.id,
            type: e.type
          }))
        }))
      }).then(() => {
        this.closeModal()
        this.$emitter.emit('refresh-resolution', {reload: false})
        this.$emitter.emit('refresh-resolutions', {reload: false})
        this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
      }).catch(error => {
        if(error.response.data.status === 422) {
          this.$snotify.error(error.response.data.message)
        } else {
          this.$snotify.error(error)
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  },
  beforeMount() {
    this.$emitter.on('open-distribution-modal', () => {
      this.initForm()
      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-distribution-modal')
  }
}
</script>
